import DataTable from '@/containers/data_table_ml/DataTable';
import styles from './TablePage.less?modules';
import './TablePage.less';
import ButtonML from '@/components/button_ml/ButtonML';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'dva';
import React, { useState } from 'react';
import { CaretRightFilled, CaretDownFilled } from '@ant-design/icons';
import { message, Menu } from 'antd';
import Loading from '@/components/Loading';
import DropDown from '@/components/dropdown/Dropdown';
import { history } from 'umi';
import TableLinkML from '@/containers/data_table_ml/table_link_ml/TableLinkML';
import { useTrigger } from '@/utils/comHook.js';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ModalConfirmML from '@/components/modal_ml/modal_confirm_ml/ModalConfirmML';

const TablePage = (props) => {
  const dispatch = useDispatch();
  const deleteTrigger = useTrigger();

  const { addRuleChange, handleDeleteSel, editable } = props || {};
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ruleManageDetail/getRuleDetailList'];
  const delLoading =
    loadingEffect.effects['ruleManageDetail/getRuleDetailList'];
  const data = useSelector((state) => state.ruleManageDetail.getRuleDetailList);
  // const [delLoading, setDelLoading] = useState(false);
  const [copyId, setCopyId] = useState('');

  //获取数据给最后一阶段加上标志(仅限于三级目录)
  const deleteEmptyArr = (datas) => {
    (datas || []).map((item) => {
      const { children = [] } = item || {};
      (children || []).map((item1) => {
        const { children: children1 = [] } = item1 || {};
        (children1 || []).map((item2) => {
          item2.isLastChild = true;
        });
        item1.isLastChild = false;
        return item;
      });
      item.isLastChild = false;
      return item;
    });
  };
  if (data) {
    deleteEmptyArr(data);
  }

  //删除规则
  const deleteRuleChange = (values) => {
    // setDelLoading(true);
    dispatch({
      type: 'ruleManageDetail/deleteRuleManaList',
      payload: {
        values: {
          ...values,
        },
      },
      callback: () => {
        // setDelLoading(false);
        message.success('删除成功');
        props.fetchData();
      },
    });
  };
  const menuClick = (key, e) => {
    if (key.key === '1') {
      setCopyId(e.id);
      message.success('复制成功');
    } else if (key.key === '2') {
      dispatch({
        type: 'ruleManageDetail/pasteRule',
        payload: {
          values: {
            hostId: copyId,
            targetId: e.id,
          },
        },
        callback: (res) => {
          if (res.code) {
            message.error(res.message);
          } else {
            message.success('粘贴成功');
          }
        },
      });
    }
  };
  //下拉的menu
  // const menu = (
  //   <Menu onClick={menuClick}>
  //     <Menu.Item key="1">复制</Menu.Item>
  //     <Menu.Item key="2">粘贴</Menu.Item>
  //   </Menu>
  // );
  const handleDetail = (record) => {
    history.push({
      pathname: '/bre/rm/rule/cfg',
      query: {
        id: record.id,
        name: record.ruleName,
        editable: editable,
      },
    });
  };
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    // {
    //   title: '规则编号',
    //   dataIndex: 'ruleNo',
    //   key: 'ruleNo',
    //   width: 100,
    // },
    {
      title: '规则名称',
      dataIndex: 'ruleName',
      key: 'ruleName',
      width: 200,
      render: (text, record) => (
        <TableLinkML text={text} handleClick={() => handleDetail(record)} />
      ),
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description',
      width: 200,
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 150,
      render: (text) => (
        <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),
    },
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 150,
      render: (text) => (
        <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
      ),
    },
    {
      title: '规则包状态',
      dataIndex: 'ruleOutputResultStatus',
      key: 'ruleOutputResultStatus',
      width: 100,
      render: (text) => {
        return (
          <span>
            {text === 'ENABLE'
              ? '启用'
              : text === 'INDETERMINATE'
              ? '不确定'
              : '禁止'}
          </span>
        );
      },
    },
    {
      title: '操作',
      render: (record) => {
        return (
          <div className={styles.handle_btn}>
            <ButtonML
              size="large"
              value="编辑"
              onClick={() => addRuleChange && addRuleChange(record, 'edit')}
              disabled={String(record.editable) === 'false'}
            />
            <ModalConfirmML
              title="是否确认删除?"
              handleOk={() => deleteRuleChange(record)}
              handleCancel={deleteTrigger.close}
              visible={deleteTrigger.visible}
              value="删除"
              icon={<ExclamationCircleOutlined />}
              disabled={String(record.editable) === 'false'}
            />
            <DropDown
              item={record}
              btnVal="其他操作"
              menu={
                <Menu
                  onClick={(e) => {
                    menuClick(e, record);
                  }}
                >
                  <Menu.Item key="1">复制</Menu.Item>
                  <Menu.Item key="2">粘贴</Menu.Item>
                </Menu>
              }
              disabled={String(record.editable) === 'false'}
            />
          </div>
        );
      },
      width: 250,
    },
  ];
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        'selectedRows: ',
        selectedRows,
      );
      const idArr = (selectedRowKeys || []).map((item) => item.id);
      handleDeleteSel(idArr);
    },
    onSelect: (record, selected, selectedRows) => {
      console.log(record, selected, selectedRows);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      console.log(selected, selectedRows, changeRows);
      const idArr = (selectedRows || []).map((item) => item.id);
      handleDeleteSel(idArr);
    },
    columnWidth: 40,
  };
  return (
    <Loading loading={delLoading}>
      <DataTable
        className="demo-test"
        // style={{ minWidth: '1547px' }}
        columns={columns}
        rowSelection={rowSelection}
        scroll={{
          x: 1547,
          y: 'calc(100vh - 160px - 3rem)',
        }}
        dataSource={data}
        loading={loading}
        isTree={true}
        expandable={{
          expandIcon: ({ expanded, onExpand, record }) => {
            const { children = [] } = record || {};
            return expanded ? (
              children.length ? (
                <CaretDownFilled
                  className="table_icon"
                  onClick={(e) => onExpand(record, e)}
                />
              ) : (
                ''
              )
            ) : children.length ? (
              <CaretRightFilled
                className="table_icon"
                onClick={(e) => onExpand(record, e)}
              />
            ) : (
              ''
            );
          },
        }}
        // changePage={(a) => {
        //   props.pageNumChange(a);
        // }}
        // changePageSize={(a) => {
        //   props.pageSizeChange(a);
        // }}
      />
    </Loading>
  );
};
export default TablePage;
